<template>
  <div class="section-toggle">
    <button type="button"
            :class="{'active': active == button.name}"
            :key="button.name"
            @click="selectBtn(button)"
            v-for="button in sections">
      {{button.text}}
    </button>
  </div>
</template>

<script>
  export default {
    name: 'sectionToggle',
    props: {
      sections: {
        type: Array
      }
    },
    computed: {
      active() {
        return this.$store.state.users.activeSec;
      }
    },
    methods: {
      selectBtn(button) {
        this.$emit('changeSec', button);
        this.$store.commit('users/SET_ACTIVE_SEC', button.name)
      }
    },
    destroyed() {
      this.$store.commit('users/SET_ACTIVE_SEC', 'more')
    }
  }
</script>

<style lang="scss" scoped>
  .section-toggle {
    padding: 20px 30px 0;
    box-shadow: 0px 1px 0px #F5F8FA;
    margin: 0 -10px;
  }

  button {
    font-family: $mm;
    font-size: 14px;
    color: $darkBlue;
    margin:  0 10px;
    position: relative;
    padding-bottom: 20px;

    &::before {
      content: '';
      position: absolute;
      width: 100%;
      height: 3px;
      background: $lightBlue;
      transition: $anim;
      left: 0;
      bottom: 0;
      opacity: 0;
    }
  }

  .active::before {
    opacity: 1;
  }
</style>
